import React from 'react';
import { Loader } from 'react-feather';

const Spinner = ({ size }: { size?: number }) => {
    return <Loader size={size} className="animate-spin stroke-saga-gray-500" />;
};

export default Spinner;
